import { mockApiReturner } from "helpers/mockApiReturner";
import { IReviewModel, ISearchFilter, IStoreDataModel, IStoreDetailData } from "./models";

export const reviewList: IReviewModel[] = [
  {
    reviewerName: " みどりんぷ さん",
    date: '2023/12/02',
    reviewedPlan: {
      highlightedName: "【ストロベリー×チョコレートブッフェ】生絞りモンブラン×ズワイ蟹含む冬の味覚ブッフェ！（土日祝90分）",
      discountRate: {
        displayable: false,
        value: 0
      },
      listed_price: 0,
      timeZone: 1,
      popularity: null,
      prices: []
    },
    usageScene: null,
    rating: {
      avg: 4,
      cooking: 4,
      atmosphere: 4,
      service: 4,
      cost: 4,
    },
    reviewContent: `13時からの予約だったのですが、片づけがあるようで、
    3階のウエイティングルームのようなところで30分待ちました。
    遅刻してきた友人がいたので丁度よかったのかもしれません。
    お店に入ると本当に素敵な眺望でした。気持ちが上がりました。
    お料理はどれも本当に美味しかったです。
    ビュッフェになると、何か大衆的なお味はあるものですが、ケーキも含めすべて美味しかったです。
    気に入ったのはピザと、ニョッキと、絶品なローストビーフと
    デザートはすべて美味しく、ホットチョコレートがあって、甘いだろうなと
    試したのですが、それはそれは美味しくくどくなく、2杯くらい頂いてしまいました。
    90分ではお話しに花が咲くと少し短いように感じました。
    お会計した後もソファで写真を快くとってくださったりと素敵な時間でした。
    少し早いランチ忘年会だったのですが、今年のすべてが素敵に感じる会でした。
    夜は高いので多分行くことはできないと思いますが、何かの記念の日に
    行けたらいいなと思いました。夜景がすてきなんでしょうね。
    素敵な時間とお料理をありがとうございました。`
  },
  {
    reviewerName: "  Minami xxx さん",
    date: '2023/12/02',
    reviewedPlan: {
      highlightedName: "【ストロベリー×チョコレートブッフェ】生絞りモンブラン×ズワイ蟹含む冬の味覚ブッフェ！（平日120分）",
      discountRate: {
        displayable: false,
        value: 0
      },
      listed_price: 0,
      timeZone: 1,
      popularity: null,
      prices: []
    },
    usageScene: null,
    rating: {
      avg: 5.0,
      cooking: 5.0,
      atmosphere: 5.0,
      service: 5.0,
      cost: 5.0,
    },
    reviewContent: `前回うかがったのがコロナ前だったので、久々うかがいました。
    3Fのラウンジにうかがってからの案内にかわっていてましたが、丁寧に案内していただけるのでよかったです。
    眺望がよく、スカイツリーも見えるし、お食事をより一層たのしめました。
    ゆっくり、熱々天ぷらもいただけ、大満足です。
    スタッフさんもみな丁寧で気持ち良いランチタイムでした。
    またうかがいます。ありがとうございました`
  },
  {
    reviewerName: "らふらんす・カズ さん",
    date: '2023/11/30',
    reviewedPlan: {
      highlightedName: "【秋限定ブッフェ】旬食材の収穫祭！秋刀魚、松茸、秋茄子、秋のフルーツを堪能！（平日120分）",
      discountRate: {
        displayable: false,
        value: 0
      },
      listed_price: 0,
      timeZone: 1,
      popularity: null,
      prices: []
    },
    usageScene: "家族との会食",
    rating: {
      avg: 5.0,
      cooking: 5.0,
      atmosphere: 5.0,
      service: 5.0,
      cost: 5.0,
    },
    reviewContent: `前回初めて利用して良かったので2度目の利用でした。
    スタッフの対応は申し分なく良かったです。
    料理ですが、全体的にはどれも美味しいです。
    ローストビーフと生搾りモンブランは何回もおかわりしました。
    ただ、ピザのチーズや具材のボリュームが少し減った様に感じました。
    席は最初窓際を案内してくれましたが、日差しが良過ぎて内側の席に変更してくれました。`
  }
];

export const filterChips = [
  {
    label: "すべて",
    number: null,
  },
  {
    label: "衛生対策",
    number: 10
  },
  {
    label: "夜景・景色",
    number: 57
  },
  {
    label: "記念日",
    number: 30
  },
  {
    label: "東京タワー",
    number: 13
  },
  {
    label: "景色",
    number: 5
  },
  {
    label: "接待・会食 ",
    number: 2
  },
  {
    label: "お子様連れ",
    number: 76
  },
  {
    label: "飲み放題",
    number: 79
  },
];

const data: IStoreDetailData[] = [
  {
    Id: "a",
    Area: "Area",
  Budgets: {
    night: {min: 1200, max: 30000},
    day: {min: 1200, max: 30000},
  },
  Intro: "Some introo",
  BusinessHours: {
    monday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    tuesday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    wednesday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    thursday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    friday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    saturday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    sunday: {
      lunch: {
        open: "7:00",
        close: "19:00",
        last_order: null
      },
      dinner: {
        open: "7:00",
        close: "19:00",
        last_order: null
      }
    },
    closed_day: []
  },
  ReviewCount: 31,
  EntityType: "Type",
  Genres: [],
  Points: {
    avg: 4.4,
    cooking: 4,
    atmosphere: 4,
    service: 4,
    cost: 4,
  },
  Images: [],
  Seats: 4,
  Conditions: [],
  Scenes: [],
  Name: "Store Name",
  PK: "PKNUMBER"
  }
];

export const mockupApis = {
  searchStores(req: ISearchFilter) {
    return mockApiReturner(data);
  },
  getStoreDetail(id: string) {
    const response = data.find(e => e.Id === id);
    return mockApiReturner(response);
  },
};
